export default class LoginRegister {
    constructor() {
        // Field validation : toggle aria-invalid for screenreaders
        window.Parsley.on('field:error', function () {
            $(this.$element).attr('aria-invalid', 'true');
        });
        window.Parsley.on('field:success', function () {
            $(this.$element).attr('aria-invalid', 'false');
        });
    }
}
